import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnergyEfficiency } from '../../../../../../../services/types/Calculator';
import { getNumberFormatted } from '../../../NumberFormatterSinSeparador';

interface Props {
  energyEfficiency: EnergyEfficiency;
  defaultUnits: number;
}

const EnergyEfficiencyDetails: React.FC<Props> = ({ energyEfficiency, defaultUnits }) => {
  const { t } = useTranslation();

  const unitsReplaced = getNumberFormatted(energyEfficiency.unitsReplaced);
  const kwhBefore = getNumberFormatted(energyEfficiency.details.kwhBefore);
  const kwhAfter = getNumberFormatted(energyEfficiency.details.kwhAfter);
  const wattageConventional = getNumberFormatted(energyEfficiency.wattageConventional);
  const wattageReplacement = getNumberFormatted(
    energyEfficiency.isCustomWattage ? energyEfficiency.customWattageReplacement : defaultUnits
  );
  const hoursPerDay = getNumberFormatted(energyEfficiency.hoursDay);
  const energySaving = getNumberFormatted(energyEfficiency.details.totalSaving);

  return (
    <div className="content-calculator" style={{ overflow: 'hidden' }}>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-4">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Number of Conventional Units Replaced')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={unitsReplaced}
            className="details-input"
            disabled
            title=""
          />
        </div>
        <div className="col-12 col-sm-5 col-md-3 col-lg-3" style={{ textAlign: 'right' }}>
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('kWh Before')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={kwhBefore}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>

      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-4">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Wattage of Conventional Units')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={wattageConventional}
            className="details-input"
            disabled
            title=""
          />
        </div>
        <div className="col-12 col-sm-5 col-md-3 col-lg-3" style={{ textAlign: 'right' }}>
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('kWh After')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={kwhAfter}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-4">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Wattage of Replacement Units')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={wattageReplacement}
            className="details-input"
            disabled
            title=""
          />
        </div>
        <div className="col-12 col-sm-5 col-md-3 col-lg-3" style={{ textAlign: 'right' }}>
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Total Annual Energy Savings')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={energySaving}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>

      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-4">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Hours of Operation per Day')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            type="text"
            id="defaultarearoadInput"
            value={hoursPerDay}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>
    </div>
  );
};

export default EnergyEfficiencyDetails;
